<div [formGroup]="parentFormGroup" class="wrap">
  <div class="color-picker-checkbox">
    <mat-checkbox class="show-color-picker-checkbox" [formControlName]="showColorPickerControlName"
    (change)="showColorPickerChecked($event)">{{title}}</mat-checkbox>
  </div>
  @if (showColorPicker) {
    <mat-form-field class="color-picker-item">
      <mat-label>Color</mat-label>
      <input matInput type="color" [value]="colorValue" (input)="onColorPickerInput($event)">
    </mat-form-field>
  }
  @if (showColorPicker) {
    <mat-form-field class="color-picker-item">
      <mat-label>HEX Color*</mat-label>
      <input matInput [formControlName]="controlName" (blur)="onHexColorBlur()" autocomplete="off">
      @if (parentFormGroup.hasError('hexColorRequired')) {
        <mat-error>HEX color is required</mat-error>
      }
    </mat-form-field>
  }
</div>
